module.exports = __webpack_public_path__ + "img/logo_sipay.4535ca46.png";